import React from "react";
import { TouchableOpacity, ScrollView } from "react-native";

import HomeIcon from "./icons/HomeIcon";
import ActivitiesIcon from "./icons/ActivitiesIcon";
import ReflectionIcon from "./icons/ReflectionIcon";
import ResolutionIcon from "./icons/ResolutionIcon";
import TrackIcon from "./icons/TrackIcon";

import { navigate } from "../../../../helpers/utils.js";
import styles from "./footerStyles";
import appPages from "../../../../appPages";

export default function Footer({ controller, selectedPage }) {
  return (
    <ScrollView
      horizontal
      style={styles.footer}
      contentContainerStyle={styles.container}
    >
      {/* Home */}
      <TouchableOpacity onPress={() => navigate(controller, "rn:home_card")}>
        <HomeIcon
          isSelected={selectedPage === "feed" || selectedPage === "home_card"}
        />
      </TouchableOpacity>

      {/* Track */}
      <TouchableOpacity onPress={() => navigate(controller, "rn:journal")}>
        <TrackIcon
          isSelected={
            selectedPage != null && selectedPage.indexOf("journal") !== -1
          }
        />
      </TouchableOpacity>

      {/* Reflection */}
      <TouchableOpacity onPress={() => navigate(controller, "sets_reflection")}>
        <ReflectionIcon isSelected={selectedPage === "sets_reflection"} />
      </TouchableOpacity>

      {/* Goals */}
      <TouchableOpacity onPress={() => navigate(controller, "rn:resolution")}>
        <ResolutionIcon isSelected={"rn:resolution".includes(selectedPage)} />
      </TouchableOpacity>

      {/* Elements */}
      <TouchableOpacity
        onPress={() => navigate(controller, appPages.elementsPage)}
      >
        <ActivitiesIcon
          isSelected={appPages.elementsPage.includes(selectedPage)}
        />
      </TouchableOpacity>
    </ScrollView>
  );
}
